import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../lib/venue";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#111114] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-xs uppercase tracking-[0.3em] text-[#F5A623] font-semibold">
            / The Word On The Street
          </span>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#FDFBF7] uppercase mt-4 leading-[0.9]">
            What the
            <br />
            <span className="text-[#F5A623]">regulars say.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="relative bg-[#0A0A0A] border border-white/10 p-8 hover:border-[#F5A623]/40 transition-colors"
            >
              <Quote
                size={36}
                strokeWidth={1.5}
                className="text-[#F5A623]/70 mb-4"
              />
              <blockquote className="text-[#FDFBF7]/85 text-lg leading-relaxed font-light">
                "{t.quote}"
              </blockquote>
              <div className="mt-6 pt-6 border-t border-white/10 flex items-center justify-between">
                <figcaption>
                  <div className="font-display text-xl uppercase text-[#FDFBF7]">
                    {t.name}
                  </div>
                  <div className="text-xs uppercase tracking-[0.2em] text-[#FDFBF7]/50 mt-1">
                    {t.role}
                  </div>
                </figcaption>
                <div className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star
                      key={k}
                      size={14}
                      fill="#F5A623"
                      className="text-[#F5A623]"
                    />
                  ))}
                </div>
              </div>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
